<template>
  <div class="pageStyle">
    <div class="pageBox">
      <!-- <div class="header">
        <div>专属AI客服</div>
        <div>{{ robotSstatus }}</div>
      </div> -->
      <div class="content" id="contentBox">
        <div class="content-box">
          <div v-for="(item, index) in talkList" :key="index">
            <!-- 机器人回答 -->
            <div v-if="item.user == 'robot'" class="robotMsgStyle item">
              <!-- 时间 -->
              <div class="time">
                <span>{{ item.time }}</span>
              </div>
              <!-- 回答 -->
              <div class="label">
                <!-- ai机器人头像 -->
                <img
                  src="https://static.xchengtech.cn/ba66119e180b4d3b8373d965bb162883.png"
                  alt=""
                />
                <span class="labelTxtBox">
                  <!-- 回答内容 -->
                  <span class="labelTxt" v-html="item.label"></span>
                  <!-- loading图标 -->
                  <!-- <i v-show="item.loadingShow" class="el-icon-loading"></i> -->
                  <div v-show="item.loadingShow" class="loadingIcon">
                    <div class="loading">
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                  <!-- 三角形图标 -->
                  <img
                    class="triangle"
                    src="https://static.xchengtech.cn/90ffe1b744d747be86b7750a29e91cc8.png"
                    alt=""
                  />
                </span>
                <!-- 评价 -->
                <!-- <div v-show="item.id">
                  <div class="evaluate" v-show="item.toEvaluateShow">
                    <span>回答是否准确？</span>
                    <span @click="toEvaluate(item.id, 'good')"
                      >准确<img src="./img/good.png" alt=""
                    /></span>
                    <span @click="toEvaluate(item.id, 'bad')"
                      >不准确<img src="./img/bad.png" alt=""
                    /></span>
                  </div>
                  <div v-show="item.evaluateTxt" class="evaluateTxt">
                    {{ item.evaluateTxt }}
                  </div>
                </div> -->
              </div>
            </div>
            <!-- 我的提问 -->
            <div v-if="item.user == 'mySelf'" class="myMsgStyle item">
              <!-- 时间 -->
              <div class="time">
                <span>{{ item.time }}</span>
              </div>
              <!-- 回答 -->
              <div class="label">
                <!-- 回答内容 -->
                <span v-html="item.label"></span>
                <img
                  src="https://static.xchengtech.cn/5269aa1c658f42ee82afc1959c8e99ae.png"
                  alt=""
                />
                <!-- 三角形图标 -->
                <img
                  class="triangle"
                  src="https://static.xchengtech.cn/4dc61c9a1b064f4985bb08fe912eff67.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <!-- 快捷选项 -->
        <div class="shortcuts">
          <span
            v-for="(item, index) in shortcutsOptions"
            :key="index"
            @click="toShortcuts(item)"
            >{{ item }}</span
          >
        </div>
        <!-- 问答框 -->
        <div class="inputBox">
          <van-field
            v-model="form.question"
            center
            clearable
            placeholder="请输入您的问题..."
            @keyup.enter="onInput"
          >
            <template #button>
              <img
                src="https://static.xchengtech.cn/5269aa1c658f42ee82afc1959c8e99ae.png"
                alt=""
                @click="onInput"
              />
            </template>
          </van-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading, Toast, Field } from "vant";
import { getDepNameByDomain } from "@/utils/index";
Vue.use(Loading);
Vue.use(Field);
import MarkdownIt from "markdown-it";
import { streamQuestion, setFaqEvaluate } from "@/api/robot";
export default {
  watch: {
    answerTxt: {
      immediate: true,
      handler(newValue, oldValue) {
        // console.log("newValue", newValue);
        let s = this.talkList.find((item) => {
          // 通过问答的id找到对应对象
          return item.answerId == this.answerId;
        });
        if (s) {
          // 赋值回答结果
          s.label = this.getTextFormat(newValue);
          s.sseId = this.form.sseEmitterId;
          // 把当前聊天定位到聊天框最下面
          this.toWindowBottom();
        }
      },
      deep: true,
    },
    answeringFlag: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue === false) {
          let s = this.talkList.find((item) => {
            // 通过问答的id找到对应对象
            return item.answerId == this.answerId - 1;
          });
          if (s) {
            let label = s.label.replaceAll("<br>", "\n");
            // 赋值回答结果
            let md = new MarkdownIt({
              breaks: true,
              html: true,
              linkify: true,
              typographer: true,
              xhtmlOut: true,
              smartquotes: true,
              smartypants: true,
            });
            let mdd = md.render(label);
            this.$set(s, "label", mdd);
            // 把当前聊天定位到聊天框最下面
            this.toWindowBottom();
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      // 对话记录
      talkList: [
        // {
        //   user: "robot",
        //   label: "欢迎咨询，请输入您想查询的问题~",
        //   time: this.getNowTime(),
        // },
      ],
      eventSource: null,
      // 提问内容
      form: {
        question: "",
        sseEmitterId: "",
        channelId: "",
        depName: getDepNameByDomain(),
      },
      // 结果集文字 原始数据
      answerTxt: "",
      // 回答中的标识
      answeringFlag: false,
      answerId: 0,
      sseId: "",
      // 机器人状态
      robotSstatus: "随时为您解答各种问题",
      // 机器人正在输入标识
      robotInputLoading: false,
      // 快捷选项
      shortcutsOptions: ["现在有哪些产品？", "转人工"],
    };
  },
  created() {},
  computed: {},
  mounted() {
    // 获取欢迎语
    this.getWelcomeTxt();
  },

  methods: {
    onInput() {
      // 如果正在回答
      if (this.answeringFlag) {
        alert("机器人正在回答问题，请稍等");
        return false;
      }

      // 如果机器人没有正在回答，并且有提问内容
      if (this.form.question) {
        // 连接sse
        this.initSSE();
      } else {
        alert("请输入需要提问的问题");
        return false;
      }
    },
    initSSE() {
      // 添加对话内容：用户提问，机器人loading回答
      this.addQuestions();
      // 正式环境
      const url = "https://api.xchengtech.cn";
      // 测试环境
      // const url = "https://work1.xchengtech.cn:8003";
      // 创建一个SSE对象，连接到后端的/chat接口
      const eventSource = new EventSource(url + "/cus/chat/getSseEmitter");
      // 监听open事件添加一个监听器，打印连接状态
      eventSource.addEventListener("open", (e) => {
        console.log("SSE连接成功");
      });
      // 监听message事件，接收后端发送的消息
      eventSource.addEventListener("message", (e) => {
        const msg = JSON.parse(e.data);
        //将返回data插入元素
        if (msg.type == "start") {
          this.form.sseEmitterId = msg.id;
          // 连接成功后，开始提问
          this.toQuestions();
        }
        if (msg.type == "append") {
          // this.robotSstatus = "正在输入中...";
          this.robotInputLoading = false;
          this.answerTxt = this.answerTxt + msg.content;
        }
        if (msg.type == "end") {
          // 关闭正在回答开关
          this.answeringFlag = false;
          // 清空回答结果（总结果合集）
          this.answerTxt = "";
          // 机器人回答完毕 关闭loading
          this.closeLoading();
          // 赋值sse给当前对象
          this.postSseId();
          // this.robotSstatus = "还有什么可以帮您？";
          // 回答完毕，id增加
          this.answerId++;
          this.toWindowBottom();
          // 注意 在回答完毕后要关闭 否则sse会自动重连 再次触发open事件
          eventSource.close();
        }
      });
      // 监听error事件添加一个监听器，打印错误信息
      eventSource.addEventListener("error", (e) => {
        console.log("Error: ", e);
        this.toRobotMsg("很抱歉，网络出错了");
        eventSource.close();
      });

      // 监听notice事件添加一个监听器，打印通知内容
      eventSource.addEventListener("notice", (e) => {
        console.log("Notice: " + e.data);
      });
    },
    toWindowBottom() {
      this.$nextTick(() => {
        let contentBox = document.getElementById("contentBox");
        contentBox.scrollTop = contentBox.scrollHeight;
      });
    },
    // 添加对话内容
    addQuestions() {
      // 添加用户提问
      this.userQuestions();
      // 添加机器人回答
      this.robotAnswer();
      // 把当前聊天定位到聊天框最下面
      this.toWindowBottom();
      // 打开正在回答结束开关
      this.answeringFlag = true;
    },
    // 调用提问接口
    toQuestions() {
      let body = {
        ...this.form,
      };
      this.form.question = "";
      streamQuestion(body)
        .then((res) => {
          if (res.status && res.status == 400) {
            this.toRobotMsg("很抱歉，网络出错了");
          }
        })
        .catch((err) => {
          console.log("err", err);
          this.toRobotMsg("很抱歉，网络出错了");
        });
    },
    // 添加用户提问
    userQuestions() {
      let body = {
        user: "mySelf",
        label: this.form.question,
        time: this.getNowTime(),
      };
      this.talkList.push(body);
    },
    // 添加机器人回答
    robotAnswer() {
      let body = {
        user: "robot",
        label: "",
        time: this.getNowTime(),
        answerId: this.answerId,
        loadingShow: true,
        evaluateTxt: "",
        toEvaluateShow: true,
      };
      this.talkList.push(body);
    },
    // 获取当前时间
    getNowTime() {
      let now = new Date();
      let timeString = now.toLocaleTimeString();
      let [hours, minutes, seconds] = timeString.split(":");
      return hours + ":" + minutes;
    },
    // 转换内容结果格式
    getTextFormat(val) {
      if (val) {
        val = val.replaceAll("\n", "<br>");
        return val;
      }
    },
    // 直接赋予机器人回复
    toRobotMsg(val) {
      let s = this.talkList.find((item) => {
        // 通过问答的id找到对应对象
        return item.answerId == this.answerId;
      });
      if (s) {
        s.label = val;
        s.loadingShow = false;
        this.answerId++;
        this.answeringFlag = false;
        this.form.question = "";
        // 把当前聊天定位到聊天框最下面
        this.toWindowBottom();
      }
    },

    // 评价
    toEvaluate(id, type) {
      console.log("id", id);
      console.log("type", type);
      let body = {
        id: id,
        evaluate: type,
      };
      if (type == "good") {
        let s = this.talkList.find((item) => {
          return item.id == id;
        });
        s.evaluateTxt = "感谢您的评价！";
        s.toEvaluateShow = false;
      }
      if (type == "bad") {
        let s = this.talkList.find((item) => {
          return item.id == id;
        });
        s.evaluateTxt = "感谢您的评价！我们会进行改进";
        s.toEvaluateShow = false;
      }
      setFaqEvaluate(body).then((res) => {
        console.log("res", res);
      });
    },
    // 机器人回答完毕 关闭loading
    closeLoading() {
      let s = this.talkList.find((item) => {
        // 通过问答的id找到对应对象
        return item.answerId == this.answerId;
      });
      if (s) {
        s.loadingShow = false;
      }
    },
    // 赋值sse给当前对象
    postSseId() {
      let s = this.talkList.find((item) => {
        // 通过问答的id找到对应对象
        return item.answerId == this.answerId;
      });
      if (s) {
        s.id = this.form.sseEmitterId;
      }
    },
    // 获取欢迎语
    getWelcomeTxt() {
      let label = `我是您的专业贷款咨询AI助手，专注于为您提供各类银行及金融机构的贷款产品信息、申请指导、方案匹配等服务。  

### 我能为您做什么？  
1. **产品推荐**：根据您的资质（如企业类型、收入、抵押物等）匹配适合的贷款产品。  
2. **方案解析**：详细解释贷款产品的额度、利率、还款方式、申请条件等。  
3. **流程指导**：协助准备材料、优化申请流程，提高通过率。  
4. **问题解答**：解决贷款相关的征信、担保、行业限制等疑问。

需要任何帮助，请随时告诉我！ 😊`;
      // 赋值回答结果
      let md = new MarkdownIt({
        breaks: true,
        html: true,
        linkify: true,
        typographer: true,
        xhtmlOut: true,
        smartquotes: true,
        smartypants: true,
      });
      let mdd = md.render(label);
      this.talkList.push({
        user: "robot",
        label: mdd,
        time: this.getNowTime(),
      });
    },
    toShortcuts(txt) {
      this.form.question = txt;
      this.onInput();
    },
  },
};
</script>


<style  scoped>
.pageStyle {
  width: 100%;
  height: 100%;
}
.pageBox {
  display: grid;
  grid-template-rows: auto 50vw;
  width: 100%;
  height: 100%;
}
/* 头部 */
.header {
  text-align: center;
  background: white;
  padding: 4vw;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 10;
}
.header div:nth-of-type(1) {
  /* padding-top: 1vw; */
  color: #2841c1;
  font-size: 6.4vw;
  font-weight: 600;
}
.header div:nth-of-type(2) {
  padding-top: 1vw;
  color: #888;
  font-size: 3.6vw;
}
.content {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  /* background-color: #f5f5f5; */
}
.content .item {
  font-size: 4vw;
}
.content-box {
  padding: 4vw;
  display: grid;
  grid-template-columns: 100%;
  gap: 6vw;
}
.content .time {
  margin-bottom: 6px;
  color: #a0a0a0;
  font-size: 3.1vw;
  text-align: center;
  margin-bottom: 4vw;
}

/* 评价 */
.content .evaluate {
  display: flex;
  padding: 4vw;
  font-size: 3.1vw;
  align-items: center;
}
.content .evaluate img {
  display: block;
  width: 20px;
  height: 20px;
  margin-left: 4px;
}
.content .evaluate span {
  display: flex;
  align-items: center;
}
.content .evaluate span:nth-of-type(1) {
  color: #909399;
}
.content .evaluate span:nth-of-type(2) {
  margin: 0 10px;
  cursor: pointer;
}
.content .evaluate span:nth-of-type(3) {
  cursor: pointer;
}
/* 评价完成标语 */
.evaluateTxt {
  padding: 4vw;
  color: #909399;
  font-size: 3.6vw;
}
.content .robotMsgStyle .label {
  display: flex;
  align-items: flex-start;
  gap: 3vw;
  font-size: 4vw;
}
.content .robotMsgStyle .label img {
  display: block;
  width: 9vw;
  height: 9vw;
}
.content .robotMsgStyle .label .labelTxtBox {
  position: relative;
  display: inline-block;
  background-color: white;
  border-radius: 4px;
  padding: 2vw 3vw;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 68vw;
}
/* 三角形 */
.content .robotMsgStyle .label .labelTxtBox .triangle {
  display: block;
  width: 3vw;
  height: 3vw;
  position: absolute;
  top: 3vw;
  left: -2vw;
}
.content .robotMsgStyle .label .labelTxt {
  line-height: 7vw;
}
/* 用户提问 */
.content .myMsgStyle .time {
  color: #a0a0a0;
  font-size: 3.1vw;
  text-align: center;
  margin-bottom: 4vw;
}
.content .myMsgStyle .label {
  position: relative;
  display: flex;
  justify-content: right;
  align-items: center;
  gap: 3vw;
}
.content .myMsgStyle .label .triangle {
  position: absolute;
  display: block;
  width: 3vw;
  height: 3vw;
  position: absolute;
  top: 3vw;
  right: 10.4vw;
}
.content .myMsgStyle img {
  border-radius: 35px;
  display: block;
  width: 9vw;
  height: 9vw;
}
.content .myMsgStyle .label span {
  word-wrap: break-word;
  word-break: break-all;
  background-color: #2841c1;
  color: #ffffff;
  border-radius: 4px;
  padding: 2vw 3vw;
  font-size: 4vw;
  max-width: 68vw;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.footer {
  border-top: 1px solid #f5f5f5;
  padding-top: 3vw;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.1);
}
.footer .inputBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3vw 4vw;
  gap: 4vw;
}
.footer .inputBox img {
  display: block;
  width: 10vw;
  height: 10vw;
  cursor: pointer;
}
.footer .inputBox .van-cell {
  background: #f5f5f5;
  border-radius: 18px;
  padding: 2.4vw 2.4vw 2.4vw 4vw;
  font-size: 4vw;
}
/* 快捷选项 */
.footer .shortcuts {
  display: flex;
  align-items: center;
  gap: 3vw;
  padding: 0 4vw;
  /* background-color: #f5f5f5; */
}

.footer .shortcuts span {
  padding: 2vw 3vw;
  border-radius: 14px;
  background-color: white;
  display: block;
  border: 1px solid #efefef;
  font-size: 3.6vw;
}

/* loading 动画 */
.loadingIcon {
  display: flex;
  justify-content: right;
}
.loadingIcon .loading,
.loadingIcon .loading > div {
  position: relative;
  box-sizing: border-box;
}

.loadingIcon .loading {
  display: block;
  font-size: 0;
  color: #000;
}

.loadingIcon .loading.la-dark {
  color: #333;
}

.loadingIcon .loading > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}

.loadingIcon .loading {
  display: flex;
  align-items: center;
  width: 32px;
  height: 4.6vw;
}

.loadingIcon .loading > div:nth-child(1) {
  animation-delay: -200ms;
}

.loadingIcon .loading > div:nth-child(2) {
  animation-delay: -100ms;
}

.loadingIcon .loading > div:nth-child(3) {
  animation-delay: 0ms;
}

.loadingIcon .loading > div {
  width: 6px;
  height: 6px;
  margin: 4px 2px;
  border-radius: 100%;
  animation: ball-pulse 1s ease infinite;
}

.loadingIcon .loading.la-sm {
  width: 26px;
  height: 8px;
}

.loadingIcon .loading.la-sm > div {
  width: 4px;
  height: 4px;
  margin: 2px;
}

.loadingIcon .loading.la-2x {
  width: 108px;
  height: 36px;
}

.loadingIcon .loading.la-2x > div {
  width: 20px;
  height: 20px;
  margin: 8px;
}

.loadingIcon .loading.la-3x {
  width: 162px;
  height: 54px;
}

.loadingIcon .loading.la-3x > div {
  width: 30px;
  height: 30px;
  margin: 12px;
}

@keyframes ball-pulse {
  0%,
  60%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  30% {
    opacity: 0.1;
    transform: scale(0.01);
  }
}
</style>


// WEBPACK FOOTER //
// src/view/robot/index.vue